import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
  icon: {
    position: "absolute",
    left: 0,
    right: 0,
    pointerEvents: "none",
    margin: "auto",
    fontSize: 20,
    color: theme.palette.grey[700],
  },
  // Icon variant shows only the centered logo: hide the input's text value and
  // the Autocomplete dropdown arrow. Uses descendant selectors so it survives
  // TextFieldBase overriding InputProps.classes.
  iconInput: {
    // The hidden value text must not widen the fixed-width prefix box.
    // MUI sets ".MuiAutocomplete-input { min-width: 30px }" (same specificity),
    // so !important is required to collapse the input and keep the icon centered
    // in the compact 48px box.
    "& .MuiInputBase-input": {
      opacity: 0,
      cursor: "pointer",
      width: "0 !important" as any,
      minWidth: "0 !important" as any,
      padding: "0 !important" as any,
    },
    "& .MuiAutocomplete-endAdornment": {
      display: "none",
    },
  },
}));

export const useInputStyles = makeStyles(() => ({
  input: {
    opacity: 0,
    cursor: "pointer",
  },
}));
